import { Button, CircularProgress, Grid } from '@material-ui/core';
import { IJobMatching } from '@orientaction/components/Form/CreateEditAdmin/Job/type';
import useJobForm from '@orientaction/components/Form/CreateEditAdmin/Job/useJobForm';
import { useAlert } from '@orientaction/hooks';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import DetailJobComponent from '../../DetailJob/DetailJobComponent';
import { useStyles } from './style';

const PreviewJob = () => {
  const classes = useStyles();
  const { id } = useParams<{ id: string }>();
  const { goBack } = useHistory();
  const [job, setJob] = useState<IJobMatching>();
  const [loading, setLoading] = useState(false);
  const { jobStoredForPreview, publishAfterPreview } = useJobForm();
  const alert = useAlert();
  useEffect(() => {
    if (jobStoredForPreview && jobStoredForPreview.job) {
      setJob(jobStoredForPreview.job);
    }
  }, [jobStoredForPreview]);

  const publishNow = async () => {
    if (job) {
      try {
        setLoading(true);
        await publishAfterPreview(id, job);
      } catch (e) {
        console.error(e);
        alert.setOpenAlert(true, "Une erreur s'est produite pendant le traitement", 'error');
      } finally {
        setLoading(true);
      }
    }
  };
  const { job: jobLoaded, loadData } = useJobForm();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    // const func = async () => {
    //   await loadData(id);
    //   // window.scrollTo(0, 0);
    // };
    // func();
    // // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DetailJobComponent
      isPreview={true}
      job={job ?? jobLoaded}
      backUrl={`/admin/emploi/annonces/${id ?? job?.id}`}>
      <Grid className={classes.footer} container={true} spacing={2}>
        <Grid item={true} xs={1} />
        <Grid item={true} xs={5}>
          <Button
            type="button"
            onClick={() => goBack()}
            className={classes.draftButton}
            variant="outlined"
            disabled={loading}
            color="primary">
            Retourner à l&apos;éditeur
          </Button>
        </Grid>
        <Grid item={true} xs={5}>
          <Button
            className={classes.publishButton}
            type="button"
            onClick={publishNow}
            variant="contained"
            color="primary"
            disabled={loading}>
            Confirmer et publier cette annonce
          </Button>
        </Grid>
      </Grid>
    </DetailJobComponent>
  );
};

export default PreviewJob;
